import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { ORG_CHART_TAB } from "../CompanyDirectory";

/**
 * `/org-chart` is now the Org-Chart tab of the Directory page (PY-13545).
 *
 * A full page load is redirected server-side by `OrgChartHandler`; this covers client-side
 * routing to the old path. The existing query is carried over because `?employeeId=` deep
 * links into the chart are load-bearing for the Minimap and employee-details breadcrumbs.
 */
const OrgChartRedirect = (): React.ReactElement => {
	const { search } = useLocation();

	const params = new URLSearchParams(search);
	params.set("tab", ORG_CHART_TAB);

	return <Navigate to={`/directory?${params.toString()}`} replace />;
};

export default OrgChartRedirect;
